import { isGuidedSurveyPwaHost } from './fieldAppHost'

type ServiceWorkerNavigator = Navigator & {
  serviceWorker?: {
    register: (scriptURL: string, options?: RegistrationOptions) => Promise<ServiceWorkerRegistration>
  }
}

export function shouldRegisterFieldAppServiceWorker(
  location = globalThis.location,
  navigatorRef = globalThis.navigator as ServiceWorkerNavigator | undefined,
): boolean {
  return Boolean(
    navigatorRef?.serviceWorker &&
      location.protocol === 'https:' &&
      isGuidedSurveyPwaHost(location.hostname),
  )
}

export function registerFieldAppServiceWorker(
  location = globalThis.location,
  navigatorRef = globalThis.navigator as ServiceWorkerNavigator | undefined,
) {
  if (!shouldRegisterFieldAppServiceWorker(location, navigatorRef)) return

  window.addEventListener('load', () => {
    navigatorRef?.serviceWorker?.register('/field-app-sw.js', { scope: '/' }).catch(() => {
      // Service worker registration is best-effort and must not block the field app.
    })
  })
}
